import React from 'react';
import Image from 'next/image';
import {
  Tabs,
  Tab,
  TabList,
  TabPanel,
  SHOPPING_TABS,
  SHOPPING_TABS_CONTENT,
} from './ShoppingTabs';
import { Button } from '@nerdwallet/currency';
import styles from './ShoppingModule.module.scss';
import {
  HOMEPAGE as analyticsBase,
  HOMEPAGE_SEGMENT_INSTRUMENTATION,
} from '~/app/lib/analytics/analytics-constants';
import useAnalytics from '~/app/lib/segment/useAnalytics';
import AutoInsuranceEntryForm from '../auto-insurance-entry-form/auto-insurance-entry-form';
import SegmentImpression from '../../segment-impression';

const ShoppingModule = (): JSX.Element => {
  const { trackSegmentTrackEvent } = useAnalytics();
  const trackAnalytics = (entityName: string) => {
    trackSegmentTrackEvent('Element Interaction', {
      entity_name: entityName,
      location: HOMEPAGE_SEGMENT_INSTRUMENTATION.vertical_comparison.location,
      interaction_type: 'select',
    });
  };

  return (
    <div className={styles.shoppingModuleWrapper}>
      <Tabs defaultValue={SHOPPING_TABS[0]}>
        <TabList>
          {SHOPPING_TABS.map((tab, index) => (
            <Tab
              name={tab}
              label={SHOPPING_TABS_CONTENT[tab].label}
              backgroundColor={SHOPPING_TABS_CONTENT[tab].backgroundColor}
              key={`${tab}_${index}`}
              entityName={SHOPPING_TABS_CONTENT[tab].analytics.tab}
            />
          ))}
        </TabList>

        {SHOPPING_TABS.map((tab, index) => {
          const { backgroundColor, mainText, secondaryText, cta, images } =
            SHOPPING_TABS_CONTENT[tab];
          const ctaEntityName = SHOPPING_TABS_CONTENT[tab].analytics.cta;
          return (
            <TabPanel name={tab} key={`${tab}_content_${index}`}>
              <div
                className={styles.card}
                style={{
                  backgroundColor,
                }}
              >
                <div className={styles.cardTextAndCTA}>
                  {secondaryText ? (
                    <div className={styles.autoInsuranceBannerContainer}>
                      <span className={styles.cardText}>{mainText}</span>
                      <span className={styles.secondaryText}>
                        {secondaryText}
                      </span>
                      <AutoInsuranceEntryForm />
                    </div>
                  ) : (
                    <>
                      <span className={styles.cardText}>{mainText}</span>
                      <SegmentImpression
                        eventName="Element Impression"
                        eventProps={{
                          entity_name: ctaEntityName,
                          location:
                            HOMEPAGE_SEGMENT_INSTRUMENTATION.vertical_comparison
                              .location,
                        }}
                      >
                        <Button
                          primary
                          href={cta?.url}
                          onClick={() =>
                            trackAnalytics(`${ctaEntityName}_click`)
                          }
                        >
                          {cta?.label}
                        </Button>
                      </SegmentImpression>
                    </>
                  )}
                </div>
                <div className={styles.desktopImage}>
                  <Image
                    src={images?.desktopURL}
                    alt={images?.alt}
                    width={536}
                    height={400}
                    sizes="536px"
                    priority={index === 0} // CC image is the hero image and should be loaded first
                  />
                </div>
                <div className={styles.tabletImage}>
                  <Image
                    src={images?.tabletURL}
                    alt={images?.alt}
                    width={1279}
                    height={549}
                    sizes="(max-width: 1280px) 100vw"
                  />
                </div>
                <div className={styles.alternativeMobileImage}>
                  <Image
                    src={images?.mobileAltURL}
                    alt={images?.alt}
                    width={750}
                    height={360}
                    sizes="(max-width: 768px) 100vw"
                  />
                </div>
              </div>
            </TabPanel>
          );
        })}
      </Tabs>
    </div>
  );
};

export default ShoppingModule;
